export const ALL_USERS = 'all';
export const INITIAL_VISITS_ONLY = 'initial_visits_only';

export const REVIEWS_USERS_FILTERS = [{ key: ALL_USERS }, { key: INITIAL_VISITS_ONLY }];

export const REVIEWS_USERS_FILTERS_KEYS = REVIEWS_USERS_FILTERS.map(({ key }) => key);
